import * as React from "react";
import { forwardRef } from "react";
const SvgNone = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.40039 14.4016V10.6235M2.40039 10.6235C6.47299 7.38806 9.52779 13.859 13.6004 10.6235V2.53556C9.52779 5.77103 6.47299 -0.699909 2.40039 2.53556V10.6235Z", stroke: "#40494D", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgNone);
export { ForwardRef as ReactComponent };
